import { motion } from "framer-motion";

const CHAPTERS = [
  { n: "01", title: "Chain-of-Custody, Uncompromised", body: "Every specimen and document is tracked, sealed, and logged from pickup to delivery — protecting the integrity of your results and legal standing." },
  { n: "02", title: "Clinical-Grade Speed", body: "STAT and scheduled routes engineered for laboratories, clinics, and legal offices where timing is not negotiable." },
  { n: "03", title: "Accredited & Discreet", body: "Certified professionals handle sensitive DNA, drug, and notarized materials with confidentiality at every step." },
  { n: "04", title: "One Partner, Every Service", body: "Courier, testing, and notary under one roof — with mobile phlebotomy arriving soon to complete the chain." },
];

const Stats = () => (
  <section id="stats" className="border-y border-border">
    <div className="max-w-[1600px] mx-auto px-5 md:px-10 grid grid-cols-2 md:grid-cols-4 divide-x divide-border">
      {[
        { k: "24/7", v: "Dispatch Availability" },
        { k: "100%", v: "Chain-of-Custody" },
        { k: "4+", v: "Core Services" },
        { k: "GA", v: "Regional Coverage" },
      ].map((s, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.08 }}
          className="py-10 md:py-14 px-5 md:px-8"
        >
          <div className="font-display font-black text-3xl md:text-5xl tracking-tighter text-primary tabular-nums">{s.k}</div>
          <div className="text-[10px] md:text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mt-3">{s.v}</div>
        </motion.div>
      ))}
    </div>
  </section>
);

export const Manifesto = () => (
  <>
    <Stats />
    <section id="manifesto" className="py-24 md:py-40">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="flex items-center gap-3 mb-16 md:mb-24">
          <span className="text-xs font-mono uppercase tracking-[0.3em] text-muted-foreground">/ Why BioFleet</span>
        </div>
        <div className="space-y-16 md:space-y-28">
          {CHAPTERS.map((c) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start border-t border-border pt-8 md:pt-12"
            >
              <div className="md:col-span-4">
                <span className="font-display font-black text-6xl md:text-8xl tracking-tighter text-outline">{c.n}</span>
              </div>
              <div className="md:col-span-8">
                <h3 className="font-display font-bold text-2xl md:text-4xl tracking-tight mb-5 leading-tight">{c.title}</h3>
                <p className="text-base md:text-lg font-mono text-muted-foreground leading-relaxed max-w-2xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  </>
);
